import { useCallback, useEffect, useState } from 'react';
import consultationService from '../../../services/consultationService';

const DEFAULT_LIMIT = 5;

/**
 * Dernières consultations du même patient (adhérent ou nom hors fiche).
 */
export default function useConsultationRecentHistory(consultation, workSiteId, limit = DEFAULT_LIMIT, refreshKey = 0) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!consultation?.id) {
      setItems([]);
      return;
    }

    const memberId = consultation.member_id;
    const patientName = consultation.patient_name?.trim();

    if (!memberId && !patientName) {
      setItems([]);
      return;
    }

    setLoading(true);
    try {
      const filters = { limit: limit + 1 };
      if (memberId) {
        filters.member_id = memberId;
      } else {
        filters.patient_name = patientName;
        if (workSiteId) filters.site_id = workSiteId;
      }

      const res = await consultationService.getConsultations(filters);
      const rows = Array.isArray(res.data) ? res.data : [];
      setItems(
        rows
          .filter((row) => row.id !== consultation.id)
          .slice(0, limit)
      );
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [consultation, limit, workSiteId]);

  useEffect(() => {
    refresh();
  }, [refresh, refreshKey]);

  return { items, loading, refresh };
}
